import { motion } from "framer-motion";
import { APPLICATIONS } from "@/data/content";

const ApplicationRow = ({ item, index }) => {
  const reversed = index % 2 === 1;

  return (
    <div
      data-testid={`application-item-${item.n}`}
      className={`grid grid-cols-1 items-center gap-10 lg:grid-cols-12 lg:gap-16 ${
        index !== 0 ? "mt-[21px] pt-[34px] lg:mt-20 lg:border-t lg:border-borderLight lg:pt-20" : ""
      }`}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6 }}
        className={`lg:col-span-6 ${reversed ? "lg:order-2" : ""}`}
      >
        <span className="font-mono text-sm text-teal">{item.n}</span>
        <h3
          data-testid={`application-item-title-${item.n}`}
          className="mt-3 font-heading text-2xl font-semibold text-ink sm:text-3xl"
        >
          {item.title}
        </h3>
        <p
          data-testid={`application-item-body-${item.n}`}
          className="mt-4 max-w-lg text-[15px] leading-relaxed text-inkSoft"
        >
          {item.body}
        </p>
        <div className="mt-6">
          <span className="text-xs font-medium uppercase tracking-[0.08em] text-inkMuted">
            {item.tagsLabel}
          </span>
          <div data-testid={`application-item-tags-${item.n}`} className="mt-3 flex flex-wrap gap-2">
            {item.tags.map((tag, i) => (
              <span
                key={tag}
                data-testid={`application-item-tag-${item.n}-${i}`}
                className="rounded-full border border-teal/15 bg-glacier px-3 py-1.5 text-sm text-teal"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, scale: 0.97 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.7 }}
        className={`lg:col-span-6 ${reversed ? "lg:order-1" : ""}`}
      >
        <div className="h-[280px] overflow-hidden rounded-3xl sm:h-[340px] lg:h-[374px]">
          <img src={item.image} alt={item.imageAlt} className="h-full w-full object-cover" />
        </div>
      </motion.div>
    </div>
  );
};

export const ApplicationsList = () => (
  <section data-testid="applications-list-section" className="bg-baseLight px-6 pt-[10px] pb-[30px] sm:py-[40px] lg:px-12 lg:py-[70px]">
    <div className="lg:mx-auto lg:max-w-[1280px]">
      {APPLICATIONS.map((item, index) => (
        <ApplicationRow key={item.n} item={item} index={index} />
      ))}
    </div>
  </section>
);
